import {AbstractService} from "@/services/AbstractService";

export abstract class AbstractPageObserver extends AbstractService
{
    abstract isApplicable(): boolean
    abstract resolve();

    async beforePageLoad() {}
    async afterPageLoad() {}
}